/**
 * Utility for preserving and appending UTM parameters to URLs and internal routes.
 */
export function withUTM(href: string, params: Record<string, string | undefined>): string {
  try {
    const isAbsolute = href.startsWith("http://") || href.startsWith("https://");
    const base = isAbsolute ? undefined : "https://finendra.com";
    const url = new URL(href, base);

    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null && value.trim() !== "") {
        url.searchParams.set(key, value.trim());
      }
    }

    if (isAbsolute) {
      return url.toString();
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return href;
  }
}

/**
 * Helper to build search parameters object for TanStack Router Link component.
 */
export function buildUTMSearch(
  existingSearch: Record<string, unknown> | undefined,
  utmParams: Record<string, string | undefined>,
): Record<string, unknown> {
  const result: Record<string, unknown> = { ...(existingSearch ?? {}) };
  for (const [k, v] of Object.entries(utmParams)) {
    if (v) result[k] = v;
  }
  return result;
}
